import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import SupplierOverviewService from 'src/modules/3rd-party-management/apis/admin/SupplierOverviewService';

export const SUPPLIER_OVERVIEW_CORPORATE_STRUCTURE_COMPARISON_QUERY_KEY = '3rd-party-management-fetch-supplier-overview-corporate-structure-comparison';

const useSupplierOverviewCorporateStructureComparison = ({
    supplierId,
    t,
    enabled = true,
}) => {
    return useQuery({
        queryKey: [SUPPLIER_OVERVIEW_CORPORATE_STRUCTURE_COMPARISON_QUERY_KEY, supplierId],
        queryFn: async () => {
            const service = SupplierOverviewService.getInstance();

            return await service.fetchCorporateStructureComparison(supplierId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!supplierId && enabled,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching corporate structure comparison data.'), {
                type: 'error',
            });
        },
    });
};

export default useSupplierOverviewCorporateStructureComparison;
